@if (enabled() === true) {
  <div [ngClass]="styleClass()">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
  </div>
}
